
    import '/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/power-design/shortcut-selector.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-power-design-shortcut-selector-demo-shortcut-selector"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/builds/1N4HJJhF/0/wepie-ee/fe/fe-base/power-design/site/docs/power-design/shortcut-selector.md?type=demo')
};